import { PropsWithChildren } from 'react';
import { PinAngleFill } from 'react-bootstrap-icons';

import { Avatar, List, Space, Typography } from 'antd';

import { getCdnUrl } from '@/helpers';
import { getTime } from '@/helpers/formatDate';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { enCommentType, IComment } from '@/interfaces/comments';
import styled, { css, StyledProp } from '@/styled';

interface IProps extends StyledProp {
  comment: IComment;
}

const CommentItem = ({ comment, className, children }: PropsWithChildren<IProps>) => {
  const isHTML = comment.type === enCommentType.html;

  const breakpoints = useBreakpoints();
  return (
    <List.Item className={className}>
      <List.Item.Meta
        avatar={breakpoints.up('md') && <Avatar size={40} src={getCdnUrl(comment.user.avatar)} />}
        title={
          <Space size={16}>
            <Typography.Paragraph>{comment.user.name}</Typography.Paragraph>
            <Typography.Text>•</Typography.Text>
            <Typography.Text type='secondary'>{getTime(comment.createdAt)}</Typography.Text>
            {comment.fixed && (
              <Typography.Text className='fixed'>
                <PinAngleFill className='icon-fixed' /> Fixado
              </Typography.Text>
            )}
          </Space>
        }
        description={
          <>
            {isHTML ? (
              <Typography.Paragraph className='comment-text'>
                <p className='comment-text' dangerouslySetInnerHTML={{ __html: comment.text }} />
              </Typography.Paragraph>
            ) : (
              <Typography.Paragraph className='comment-text'>{comment.text}</Typography.Paragraph>
            )}
            {children}
          </>
        }
      />
    </List.Item>
  );
};

export default styled(CommentItem)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-block-end: 0px !important;

    .ant-list-item-meta {
      width: 100%;
    }

    .ant-list-header {
      padding-block: 0;
    }

    .comment-text {
      padding-bottom: ${theme.space.pxToRem(6)};
      white-space: pre-line;
      color: ${theme.colorTextBase};
      font-size: ${theme.space.pxToRem(16)};
      margin: 0;

      img {
        width: 100%;
      }
    }

    .ant-typography {
      margin: 0;
    }

    span.ant-typography {
      color: ${theme.colorTextSecondary};
    }

    .fixed.ant-typography {
      color: ${theme.palette.gray[0]};
    }

    .icon-fixed {
      rotate: 314deg;
      margin-right: 8px;
    }
  `
);
